// @ts-strict-ignore
/* eslint-disable valid-typeof */
const calculateMonthlyRateCreditCard = (monthlyInterest) => {
  let x = 0
  if (!monthlyInterest > 0) {
    return x
  }
  x = monthlyInterest / 100
  x = Math.pow(x + 1, 1 / 12)
  x = (x - 1) * 100
  return x >= 0 ? x : 0
}

export const calculateTotalInterestAndPeriod = (balance, apr, repayment) => {
  let totalInterest = 0
  let periods = 0
  let workingBalance
  let interestPayment
  const breakLoopPeriod = 1200
  const interestRate = calculateMonthlyRateCreditCard(apr) / 100
  workingBalance = balance
  interestPayment = balance * interestRate
  totalInterest += interestPayment
  while (workingBalance + interestPayment > repayment) {
    workingBalance = workingBalance - repayment + interestPayment
    interestPayment = workingBalance * interestRate
    totalInterest += interestPayment
    periods++
    if (periods > breakLoopPeriod) {
      return {
        error: 'The payment period is higher than 100 years.',
      }
    }
  }
  return {
    interest: Math.ceil(totalInterest),
    period: periods > 0 ? periods + 1 : 1,
    total: balance + Math.ceil(totalInterest),
  }
}

export const calculateMinimumRepayment = (balance, apr, minPercentage, minPayment) => {
  const monthlyInterestRate = calculateMonthlyRateCreditCard(apr)
  const minRepayment = Math.ceil(((minPercentage + monthlyInterestRate) * balance) / 100)
  return Math.max(minPayment, minRepayment)
}

const throwTypeError = (expected, actual) => {
  throw new Error(`Invalid type expected type ${expected} but received type ${actual}`)
}
export const checkTypes = (value, calcType) => {
  Object.entries(value).map(([k, v]) =>
    typeof v === calcType[k] ? true : throwTypeError(calcType[k], typeof v),
  )
}
